module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAbCAYAAACN1PRVAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADmSURBVHgB7ZXhDYIwEEa/Gv7rCG4AG9gNHEFHYAO7ghM4gmyAbiAb6AZsUK+JmAZs6SltjPElFwJN70HvWoBfRdg3WusdXSSmoxJC7AdPSVTqOKjOMbN8a8RBvpJFJ/OMtRQN+OQUC66soeJKMKEa1XA02dcs48q0EhLJzhRb8DlSFGDKQDW7ggktRusa88lymngAnyXekJk3vGE88QZcTMv2jplTwBwZcFw98/i+bG6SwU8BBtlIohoTknRTp5C1qWRGVHY3vpqZP2yFz7jQwTDc5L3WV4iJJVOIzUOmkIKADfzHyR3S+eGTanekqQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/Images/messageicons.png
// module id = 1127
// module chunks = 0